@if (langList.length > 1) {
  <div>
    <button mat-button [matMenuTriggerFor]="menu" class="btn app-btn-lang" aria-haspopup="menu" attr.aria-label="{{'Language Selector'|translate}}">
      <i class="fa-solid fa fa-globe ml-1 mr-1"></i> <span translate>{{ langSvc.currLangName ? langSvc.currLangName : 'Languages'}}</span> <i class="fa fa-angle-down ml-1 mr-1"></i>
    </button>
    <mat-menu #menu="matMenu" class="lang-menu" role="navigation" [attr.aria-label]="'Language Selector Navigation'|translate">
      @for (lang of langList; track lang) {
        <button mat-menu-item
          class="dropdown-item lang-dropdown-item"
          [class.current]="isCurrentLang(lang)"
          (click)="langSvc.langSelected(lang)"
          [title]="('langMenu-'+lang?.origin)|translate"
          translate>
          <span class="flag flag-icon-background flag-icon {{lang?.flag}} mx-1"></span>
          {{lang?.name}}
        </button>
      }
    </mat-menu>
  </div>
}
